import axios from "axios";
import { useEffect, useState } from "react";
import { FcCancel } from "react-icons/fc";
import { FiEdit } from "react-icons/fi";
import { VscSave } from "react-icons/vsc";
import config from "../../config";

const PriceEdit = ({ list, mobile = false }) => {
    const [selectedId, setSelectedId] = useState(null)
    const [editOn, setEditOn] = useState(false)
    const [price, setPrice] = useState(list.prevClosePrice)
    const [errprice, setErrPrice] = useState("")
    const [err, setErr] = useState("")

    const handleEditOn = (rowId) => {
        setPrice(rowId.prevClosePrice)
        setEditOn(true)
        setErr("")
    }

    useEffect(() => {
        //const newprice = parseInt(price)
        setPrice(price)
    }, [price])

    const handleEditCancel = () => {
        setEditOn(false)
        setErr("")
        setErrPrice("")
        setPrice(list.prevClosePrice)
    }

    const handleEditSave = async (stock) => {

        setErrPrice("")
        var errCount = 0;

        if (price == null || price == '' || parseFloat(price) < 1) {
            setErrPrice("* price min 1 ")
            errCount++;
        }

        if (errCount === 0) {

            try {
                stock.prevClosePrice = price;
console.log("Before update..." + stock);
                const res = await axios.post(config.BL_API_URL+"/stock/v1/updateStock",
                    stock);
                    setPrice(0.0);
                
                if (res.data != null && res.data.status === "Success") {
                    setEditOn(false);
                    setErrPrice(0.0);
                }
                else
                    setErr("backend error")

            } catch (err) {
                setErr("Server error..." + err);
                setEditOn(false);
                
            }
        }
    }

    if (mobile) {
        return (
            <div className="rounded-lg border border-gray-200 bg-white p-3.5 shadow-sm">
                <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                        <p className="text-xs uppercase tracking-wide text-gray-500">Scrip Name</p>
                        <p className="text-base font-semibold text-gray-800 break-words leading-tight">{list.scriptName}</p>
                    </div>
                    {!editOn && (
                        <button onClick={() => handleEditOn(list)} type="button" className="inline-flex items-center gap-1 rounded-md border border-blue-100 px-3 py-1.5 text-sm font-semibold text-blue-600">
                            <FiEdit className="text-sm" />Edit
                        </button>
                    )}
                </div>

                <div className="mt-2">
                    <p className="text-xs uppercase tracking-wide text-gray-500">Price</p>
                    {!editOn && <p className="text-base text-gray-900 font-medium">{list.prevClosePrice}</p>}
                    {editOn && (
                        <input
                            onChange={(e) => setPrice(e.target.value)}
                            value={price}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    handleEditSave(list);
                                }
                            }}
                            type="number"
                            name="price"
                            id="price"
                            className="mt-1 w-full rounded-md border border-gray-300 px-3 py-2 text-base"
                        />
                    )}
                </div>

                {editOn && (
                    <div className="mt-3 flex items-center gap-2">
                        <button onClick={() => handleEditSave(list)} type="button" className="inline-flex items-center gap-1 rounded-md border border-green-200 px-3 py-1.5 text-sm font-semibold text-green-700">
                            <VscSave className="text-sm" />Save
                        </button>
                        <button onClick={() => handleEditCancel()} type="button" className="inline-flex items-center gap-1 rounded-md border border-red-200 px-3 py-1.5 text-sm font-semibold text-red-600">
                            <FcCancel className="text-sm" />Cancel
                        </button>
                    </div>
                )}

                {(err || errprice) && <p className="mt-2 text-sm text-red-500">{err} {errprice}</p>}
            </div>
        );
    }

    return (
        <>
            <td className="px-6 w-1/2 whitespace-wrap text-gray-800 border">{list.scriptName}</td>
            <td className="px-6 w-1/2 whitespace-nowrap text-gray-800 border">
                {!editOn && list.prevClosePrice}
                {editOn && 
                    <input
                        onChange={e => setPrice(e.target.value)} value={price}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                handleEditSave(list);
                            }
                        }}
                        type="number" name="price" id="price" placeholder=""
                        className="border-2 shadow-sm text-bold border-gray-400" />
                }
            </td>
            <td className="px-6 w-1/2 whitespace-nowrap text-gray-800 border">
                {!editOn &&
                    <span onClick={() => handleEditOn(list)} type="button" className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-400 hover:text-blue-600 cursor-pointer">
                        <FiEdit className="text-base" />Edit
                    </span>
                }
                {editOn &&
                    <span onClick={() => handleEditSave(list)} type="button" className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-400 hover:text-blue-600 cursor-pointer">
                        <VscSave className="text-blue-600 text-base" />Save
                    </span>
                }

                {editOn &&
                    <span onClick={() => handleEditCancel()} type="button" className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-red-400 hover:text-red-600 cursor-pointer">
                        <FcCancel className="ml-2 text-red-600 text-base" />Cancel
                    </span>
                }
                <br /><span className="text-red-400">{err} {errprice}</span>
            </td>
        </>
    )
}

export default PriceEdit
